<template>
    <div class="payment_result">
        <div class="description">
            결제가 정상적으로 되었습니다.<br>
            마이페이지 > 아이템에서 <span>[사용하기]</span> 로 포인트를 지급 받으실수 있습니다.
        </div>
       <div class="btn_part">
           <div class="btn_wrap"><base-button-sm mode="darkblue" @click="close()">확 인</base-button-sm></div>
           <div class="btn_wrap"><base-button-sm mode="orange" @click="goItem()">사용하기</base-button-sm></div>
       </div>        
    </div>
</template>
<script>
export default {
    name:'payment_result',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[

    ],
    components:{

    },
    mounted() {
    },
    methods:{
        close()
        {
            window.close();
        },
        goItem(){
            if(this.$store.state.sets.mode === 'PC')
            {
                window.close();
                opener.location.href= '/mypage/item/buy';    
            }else{
                this.$router.push({ name: 'm_MyInfo_Item_Buy'});
            }
           
        }
    }
}
</script>
<style lang="scss" scoped>
.payment_result{
    padding-top:30px;
    .description{        
        background: white;
        padding: 20px 10px;
        border-radius: 10px;
        width: 80%;
        margin:0 auto;
        font-size:16px;
        font-family: nanumgothic;
        text-align: center;
        span{
            font-weight: bold;
        }
    }
    .btn_part{
        margin-top: 20px;
        display: flex;
        justify-content: center;
        .btn_wrap{
            width:120px;
            padding:10px;
        }
    }
}
</style>